import { MedicineBoxOutlined, CopyOutlined } from '@ant-design/icons';
import DashboardIcon from '../../../../Assets/Icons/DashboardIcon';
import SettingsIcon from '../../../../Assets/Icons/SettingsIcon';
import DoctorsIcon from '../../../../Assets/Icons/DoctorsIcon';
import TranscriptionistsIcon from '../../../../Assets/Icons/TranscriptionistsIcon';
import ReviewersIcon from '../../../../Assets/Icons/ReviewersIcon';
import DataIcon from '../../../../Assets/Icons/DataIcon';
import ToolIcon from '../../../../Assets/Icons/ToolIcon';
import ReportsIcon from '../../../../Assets/Icons/ReportsIcon';
import AvailableJobsIcon from '../../../../Assets/Icons/AvailableJobsIcon';
import BillingsIcon from '../../../../Assets/Icons/BillingsIcon';
import AuditIcon from '../../../../Assets/Icons/AuditIcon';
import BillersIcon from '../../../../Assets/Icons/BillersIcon';
import AdminsIcon from '../../../../Assets/Icons/AdminsIcon';
import RosterIcon from '../../../../Assets/Icons/RosterIcon';
import DictionaryIcon from '../../../../Assets/Icons/DictionaryIcon';
import FacilityIcon from '../../../../Assets/Icons/FacilityIcon';

const clinicAdminSidebarConfig = [
  {
    key: '0',
    name: 'Dashboard',
    link: '/dashboard',
    icon: DashboardIcon
  },

  // {
  //   key: '1',
  //   name: 'Admins',
  //   link: '/dashboard/admins',
  //   icon: AdminsIcon
  // },
  // {
  //   key: '2',
  //   name: 'Doctors',
  //   link: '/dashboard/doctors',
  //   icon: DoctorsIcon
  // },
  // {
  //   key: '3',
  //   name: 'Transcriptionists',
  //   link: '/dashboard/transcriptionists',
  //   icon: TranscriptionistsIcon
  // }

  // {
  //   key: '5',
  //   name: 'Billers',
  //   link: '/dashboard/Billers',
  //   icon: BillersIcon
  // },
  {
    key: '6',
    name: 'Jobs',
    link: '/dashboard/jobs-list/ready',
    icon: AvailableJobsIcon
  },

  {
    key: '7',
    name: 'Audit',
    link: '/dashboard/audit',
    icon: AuditIcon
  },
  {
    key: '8',
    name: 'Roster',
    link: '/dashboard/roster',
    icon: RosterIcon
  },
  {
    key: '4',
    name: 'Users',
    link: '/dashboard/UsersPage',
    icon: ReviewersIcon
  },
  {
    key: '9',
    name: 'Settings',
    link: '/dashboard/settings',
    icon: SettingsIcon
  },
  // {
  //   key: '10',
  //   name: 'Billing',
  //   link: '/dashboard/billing',
  //   icon: BillingsIcon
  // }
];
const billersSidebarConfig = [
  {
    key: '10',
    name: 'Jobs',
    link: '/dashboard/biller',
    icon: BillingsIcon
  },
  {
    key: '3',
    name: 'Roster',
    link: '/dashboard/roster',
    icon: RosterIcon
  },
  {
    key: '2',
    name: 'Audit',
    link: '/dashboard/biller-audit',
    icon: AuditIcon
  }
];
const adminSidebarConfig = [
  {
    key: '0',
    name: 'Dashboard',
    link: '/dashboard',
    icon: DashboardIcon
  },
  // {
  //   key: '1',
  //   name: 'Admins',
  //   link: '/dashboard/admins',
  //   icon: AdminsIcon
  // },
  // {
  //   key: '2',
  //   name: 'Doctors',
  //   link: '/dashboard/doctors',
  //   icon: DoctorsIcon
  // },
  // {
  //   key: '3',
  //   name: 'Transcriptionists',
  //   link: '/dashboard/transcriptionists',
  //   icon: TranscriptionistsIcon
  // },
  // {
  //   key: '4',
  //   name: 'Reviewers',
  //   link: '/dashboard/reviewers',
  //   icon: ReviewersIcon
  // },

  {
    key: '5',
    name: 'Jobs',
    link: '/dashboard/jobs-list/available',
    icon: AvailableJobsIcon
  },

  {
    key: '6',
    name: 'Audit',
    link: '/dashboard/audit',
    icon: AuditIcon
  },
  {
    key: '9',
    name: 'Roster',
    link: '/dashboard/roster',
    icon: RosterIcon
  },
  {
    key: '4',
    name: 'Users',
    link: '/dashboard/UsersPage',
    icon: ReviewersIcon
  },
  {
    key: '7',
    name: 'Settings',
    link: '/dashboard/settings',
    icon: SettingsIcon
  },
  // {
  //   key: '8',
  //   name: 'Billing',
  //   link: '/dashboard/billing',
  //   icon: BillingsIcon
  // }
];
const cascadeGodSidebarConfig = [
  {
    key: '1',

    name: 'Dictionary',

    link: '/dashboard/dictionary',

    icon: AdminsIcon
  },
  {
    key: '2',

    name: 'UserManagement',

    link: '/dashboard/user-management',

    icon: ReportsIcon
  },
  {
    key: '3',

    name: 'Facility',

    link: '/dashboard/facility-management',

    icon: FacilityIcon
  },
  {
    key: '4',

    name: 'MIPS Management',

    link: '/dashboard/mips-management',

    icon: SettingsIcon
  },
  {
    key: '5',

    name: 'NTA',

    link: '/dashboard/nta',

    icon: MedicineBoxOutlined
  },
  {
    key: '6',

    name: 'Copy k2p',

    link: '/dashboard/copy-k2p',

    icon: CopyOutlined
  },
  // {
  //   key: '4',
  //   name: 'Logs',
  //   link: '/dashboard/audit-logs',
  //   icon: AuditIcon
  // }
];

const reviewerSidebarConfig = [
  {
    key: '1',
    name: 'Jobs',
    link: '/dashboard/jobs-list/available',
    icon: AvailableJobsIcon
  },
  // {
  //   key: '1',
  //   name: 'Data',
  //   link: '/dashboard/data',
  //   icon: DataIcon,
  //   disabled: true

  // },
  // {
  //   key: '2',
  //   name: 'Tool',
  //   link: '/dashboard/tool',
  //   icon: ToolIcon,
  //   disabled: true
  // },
  // {
  //   key: '3',
  //   name: 'Reports',
  //   link: '/dashboard/reports',
  //   icon: ReportsIcon,
  //   disabled: true
  // },
  {
    key: '4',
    name: 'Settings',
    link: '/dashboard/settings',
    icon: SettingsIcon
  }
];

const doctorSidebarConfig = [
  {
    key: '0',
    name: 'Dashboard',
    link: '/dashboard',
    icon: DashboardIcon
  },
  {
    key: '1',
    name: 'Jobs',
    link: '/dashboard/jobs-list/available',
    icon: AvailableJobsIcon
  },
  {
    key: '2',
    name: 'Audit',
    link: '/dashboard/audit',
    icon: AuditIcon
  },
  {
    key: '4',
    name: 'Roster',
    link: '/dashboard/roster',
    icon: RosterIcon
  },
  {
    key: '3',
    name: 'Settings',
    link: '/dashboard/settings',
    icon: SettingsIcon
  }
];

const scribeSidebarConfig = [
  {
    key: '1',
    name: 'Jobs',
    link: '/dashboard/jobs-list/my-jobs/in-progress',
    icon: AvailableJobsIcon
  }
];

const sidebarConfigMap = new Map([
  ['admin', adminSidebarConfig],
  // ['transcriptionist', transcriptionistSidebarConfig],
  ['reviewer', reviewerSidebarConfig],
  ['doctor', doctorSidebarConfig],
  ['clinicAdmin', clinicAdminSidebarConfig],
  ['biller', billersSidebarConfig],
  ['cascadeGod', cascadeGodSidebarConfig],
  ['scribe', scribeSidebarConfig]
]);

export const sideMenuContents = userType => sidebarConfigMap.get(userType);
